<template>
  <el-dialog title="客服信息"
             :visible.sync="serviceInfo_show.flag"
             width="30%">
    <div class="service_view">
      <div><span>客服微信：</span><span>{{serviceInfo.kfwechat}}</span></div>
      <div><span>客服QQ：</span><span>{{serviceInfo.kfqq}}</span></div>
      <div><span>客服电话：</span><span>{{serviceInfo.kftel}}</span></div>
    </div>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="serviceInfo_show.flag = false">取 消</el-button>
      <el-button type="primary"
                 @click="serviceInfo_show.flag = false">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { apiService } from '@/request/api'
export default {
  data () {
    return {
      //   客服信息
      serviceInfo: {},

    }
  },
  props: {
    serviceInfo_show: {
      required: true,
      type: Object,
      default: { flag: false }
    }

  },
  methods: {
    //   -------------获取客服信息-------------
    async getService () {
      let res = await apiService({
      })
      if (res.errno == 0) {
        this.serviceInfo = res
      }
    },
  },
  created () {
    this.getService()
  }
}
</script>

<style>
</style>